import { useDispatch, useSelector } from 'react-redux';
import {
  onSegmentAdded,
  selectAreSegmentsValid,
  selectHighestSegmentOrder
} from '../../segment-controls.slice';
import { SegmentChangedPayload } from '../../segment-controls.types';
import { createSegment } from '../../factories/segment-factory';
import TooltipLegacy from 'common/components/tooltip/tooltip-legacy';
import { RootState } from 'app/store';

interface AddSegmentButtonProps {
  componentId: string;
}

const AddSegmentButton = (props: AddSegmentButtonProps) => {
  const { componentId } = props;
  const dispatch = useDispatch();
  const highestExistingSegmentOrder = useSelector((state: RootState) =>
    selectHighestSegmentOrder(state, componentId)
  );
  const isEnabled = useSelector((state: RootState) =>
    selectAreSegmentsValid(state, componentId)
  );

  const onAddSegment = () => {
    const payload: SegmentChangedPayload = {
      componentId,
      segment: createSegment(highestExistingSegmentOrder + 1)
    };

    dispatch(onSegmentAdded(payload));
  };

  const styleClasses = isEnabled
    ? 'text-primary-300 hover:text-primary-500'
    : 'text-neutral-400';

  return (
    <button
      onClick={onAddSegment}
      disabled={!isEnabled}
      className={`${styleClasses} group relative md:flex flex items-center justify-center transition-all`}
    >
      {!isEnabled ? (
        <TooltipLegacy positionClasses="bottom-7 left-1/2 -translate-x-1/2">
          <div className="whitespace-nowrap text-sm">
            Please select a segment
          </div>
        </TooltipLegacy>
      ) : (
        <></>
      )}
      <span className="underline text-sm">Add Segment</span>
    </button>
  );
};
export default AddSegmentButton;
